/* eslint-disable no-undef */
import axios from "axios";
import useConfig from 'utils/config'

const { END_POINT_URL, CMS_END_POINT_URL } = useConfig();

// const axiosMain = axios.create({
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

export const blogMain = axios.create({
  baseURL: CMS_END_POINT_URL,
})
const axiosMain = axios.create({
    baseURL: END_POINT_URL,
    headers: {
        'Content-Type': 'application/json',
    },
})

axiosMain.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      const isLogoutEndpoint = error.config?.url?.includes("/user/logout");
      if (!isLogoutEndpoint) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("toaster-type");
        localStorage.removeItem("userId");
        localStorage.removeItem("persist:root");
        window.location.href = "/login";
        // Return a never-resolving promise so no toast fires while the page redirects
        return new Promise(() => {});
      }
      // For the logout endpoint itself, return the response so the logout saga can finish cleanly
      return error.response;
    }
    return error.response;
  }
);

export default axiosMain;
